import React from 'react';

export const FAQIcon = ({ isExpanded }) => {
  if (isExpanded) {
    return (
      <div className="d-flex flex-column align-items-end">
        <div>
          <svg
            width="34"
            height="25"
            viewBox="0 0 34 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className="faq-icon-up"
            style={{
              display: 'flex',
              padding: '8px',
              flexDirection: 'column',
              alignItems: 'flex-start',
              gap: '10px',
              width: '34px',
              height: '25px'
            }}
          >
            <path
              d="M26 17L17 8L8 17"
              stroke="white"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </div>
      </div>
    );
  }

  return (
    <div>
      <svg
        width="34"
        height="25"
        viewBox="0 0 34 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="faq-icon-down"
        style={{
          display: 'flex',
          padding: '8px',
          flexDirection: 'column',
          alignItems: 'flex-start',
          gap: '10px',
          width: '34px',
          height: '25px'
        }}
      >
        <path
          d="M8 8L17 17L26 8"
          stroke="#2AAE3F"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </div>
  );
};
